// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"503c9e20","856":"4d9a0ec0","952":"ee201f83","960":"4fdbd224"}[chunkId] + ".chunk.js";
};